/**
 * @generated SignedSource<<1cf9c25403fa9693c587be3afba8da4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type maintenance_Query$variables = {};
export type maintenance_Query$data = {
  readonly viewer: {
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"maintenance_viewer">;
  } | null;
};
export type maintenance_Query = {
  variables: maintenance_Query$variables;
  response: maintenance_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "maintenance"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"maintenance\")"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "maintenance_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "maintenance_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "maintenance_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "downForMaintenance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "90c746640415e5ed2108cc896d94d606",
    "id": null,
    "metadata": {},
    "name": "maintenance_Query",
    "operationKind": "query",
    "text": "query maintenance_Query {\n  viewer {\n    component(name: \"maintenance\")\n    ...maintenance_viewer\n    id\n  }\n}\n\nfragment maintenance_viewer on Viewer {\n  component(name: \"maintenance\")\n  downForMaintenance\n}\n"
  }
};
})();

(node as any).hash = "7cada36d13ea0860fe5d9b27f09eef8b";

export default node;
